import React, { useState, useRef, useEffect } from "react";
import { useT } from "../i18n/LanguageContext";
import { ChevronDown } from "lucide-react";

export const LanguageSwitcher = () => {
  const { lang, setLang, languages } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = languages.find((l) => l.code === lang) || languages[0];

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={ref} data-testid="language-switcher">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-full backdrop-blur-md bg-black/40 border border-white/15 text-[var(--pn-milk)] text-[13px] hover:border-[var(--pn-amber)]/60 transition-all duration-300"
        aria-label="Cambia lingua"
        data-testid="lang-toggle"
      >
        <span className="text-[18px] leading-none">{current.flag}</span>
        <span className="hidden sm:inline tracking-wider uppercase text-[11px] text-[var(--pn-cream)]/75">
          {current.code}
        </span>
        <ChevronDown size={13} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="absolute top-full right-0 mt-2 z-50 min-w-[170px] py-2 rounded-xl backdrop-blur-xl bg-[rgba(20,14,10,0.95)] border border-[var(--pn-amber)]/25 shadow-2xl">
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-2.5 text-left text-[14px] transition-colors ${
                l.code === lang
                  ? "text-[var(--pn-amber)] bg-[var(--pn-amber)]/5"
                  : "text-[var(--pn-cream)]/85 hover:text-[var(--pn-amber)] hover:bg-white/[0.03]"
              }`}
              data-testid={`lang-option-${l.code}`}
            >
              <span className="text-[18px] leading-none">{l.flag}</span>
              <span className="font-light">{l.label}</span>
              {l.code === lang && <span className="ml-auto text-[12px]">●</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
